<template>
  <el-dialog
    title="选择内容链接"
    :visible.sync="visible"
    width="480px"
    append-to-body
    :close-on-press-escape="false">
    <div class="content-wrap">
      <el-tabs
        v-model="activeName"
        @tab-click="handleClick">
        <el-tab-pane
          label="追溯页面"
          name="10">
          <!-- <integral-task :linkType="4" /> -->
          <el-tag
            type="success"
            effect="plain"
            @click="select({linkType: 10, link: null, contentType: null , title: '追溯详情'})">
            追溯详情
          </el-tag>
        </el-tab-pane>
      </el-tabs>
    </div>
    <template slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">
        关 闭
      </el-button>
      <!-- <el-button
        type="primary"
        :loading="loading"
        @click="addTemplate(-1)">自定义</el-button> -->
    </template>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
// import LotteryGoodsInfo from './busi-content/lottery-goods-info'
// import DiscountGoodsInfo from './busi-content/discount-goods-info.vue'
// // import GoodsGroupInfo from './busi-content/goods-group-info.vue'
// import GoodsInfo from './busi-content/goods-info.vue'
// // import IntegralTask from './busi-content/integral-task.vue'
// import MessageInfo from './busi-content/message-info.vue'
export default {
  name: 'ContentSelectModal',
  components: { },
  data() {
    return {
      loading: false,
      visible: false,
      activeName: '10',
      row: {}
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    })
  },
  methods: {
    select(item) {
      console.log(item)
      this.$emit('handleSelect', item, this.row.$index)
      this.toggleModal(false)
    },
    toggleModal(visible) {
      this.visible = visible
    },
    handleClick() {},
    init(row, $index) {
      this.row = {
        ...row,
        $index
      }
      this.toggleModal(true)
    }
  }
}
</script>
<style lang="stylus">
.content-wrap {
  .el-tabs__content {
    height: 200px;
  }

  .el-tag {
    cursor: pointer;
  }

  .el-tag+.el-tag {
    margin-left: 8px;
  }
}
</style>
